import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSettings } from '@/hooks/useSettings';

const DEFAULT_NUMBER = '41765593993';

export default function WhatsAppButton() {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);
  const { pathname } = useLocation();
  const settings = useSettings();

  if (pathname.startsWith('/admin')) return null;

  const number = (settings?.whatsapp_number || DEFAULT_NUMBER).replace(/[^\d]/g, '');
  const message = settings?.whatsapp_message || t('pub.whatsapp_default_msg');
  const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('shared.whatsapp_contact')}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="fixed z-50 flex flex-row-reverse items-center gap-3 cursor-pointer no-underline"
      style={{
        bottom: '20px',
        left: '20px',
        filter: 'drop-shadow(0 4px 12px rgba(37,211,102,0.35))',
      }}
    >
      {/* Tooltip */}
      <div
        className="hidden sm:block whitespace-nowrap px-3 py-2 rounded-full text-xs font-label font-semibold text-white transition-all duration-300"
        style={{
          background: 'rgba(18,140,126,0.95)',
          opacity: hovered ? 1 : 0,
          transform: hovered ? 'translateX(0)' : 'translateX(8px)',
          pointerEvents: 'none',
        }}
      >
        {t('shared.whatsapp_tooltip')}
      </div>

      {/* Button */}
      <div
        className="w-14 h-14 flex items-center justify-center rounded-full transition-transform duration-200"
        style={{
          background: 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)',
          transform: hovered ? 'scale(1.08)' : 'scale(1)',
        }}
      >
        {/* Pulse ring */}
        <span
          className="absolute w-14 h-14 rounded-full animate-ping"
          style={{ background: 'rgba(37,211,102,0.35)' }}
        ></span>
        <i className="ri-whatsapp-line text-white text-2xl relative z-10"></i>
      </div>
    </a>
  );
}